import { render } from "./AppLogin.vue?vue&type=template&id=96808a22&scoped=true"
import script from "./AppLogin.vue?vue&type=script&lang=js"
export * from "./AppLogin.vue?vue&type=script&lang=js"

import "./AppLogin.vue?vue&type=style&index=0&id=96808a22&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96808a22"]])

export default __exports__